<template>
  <div class="login-container">
    <div class="overlay-loader" v-if="state.sessions.loading">
      <div class="wrap">
        <div id="pulse1" />
        <div id="pulse2" />
      </div>
    </div>
    <b-container>
      <b-row class="py-3 align-items-center">
        <b-col md="10" sm="6">
          <div class="d-flex align-items-center justify-content-between">
            <div class="logo">
              <img src="../assets/images/zwingBlack.svg" alt="ZWING" />
            </div>
            <!-- <div class="d-flex align-items-center system-name">
              <b-icon icon="laptop" class="mr-2"></b-icon>
              <p class="mb-0" v-text="systemName"></p>
              </div> -->
          </div>
        </b-col>
        <b-col md="2" sm="6" class="justify-content-between outline-dropdown">
          <b-dropdown text="WebPOS" disabled block variant="outline-secondary">
          </b-dropdown>
          <!--  <b-button variant="outline-secondary" 
                  block 
                  class="platform-switch d-flex justify-content-between align-items-center">WebPOS 
                <b-icon icon="chevron-right"></b-icon>
              </b-button> -->
        </b-col>
      </b-row>
    </b-container>
    <div class="login">
      <b-container>
        <b-row>
          <b-col align-self="center" lg="5" class="mx-auto login-wrapper">
            <div class="text-center">
              <h2 v-text="greetMessage" />
              <p class="text-muted">Welcome to ZWING POS</p>
            </div>

            <!-- <p class="mt-40" v-if="isLoggedIn">
            Please enter your phone number to start.
          </p> -->
            <!-- <button class="btn btn-success" @click="postData">Cool</button> -->
            <!-- <pre style="color:red;">{{ changeData }}</pre> -->
            <form @submit.prevent="login" :class="{ 'is-loading': loading }">
              <div class="input-box mt-40">
                <ZWInput
                  labelText="Enter Phone Number"
                  v-model="mobile"
                  type="number"
                  :inputlength="
                    parseInt(state.system.country_details.phone_digit)
                  "
                  :disabled="isLoading"
                  :id="'login-user'"
                  :error="loginMobClass"
                  @clearError="
                    (passwordType = 'password'),
                      $store.commit('notifications/clearErrMessage'),
                      $store.commit('sessions/clearLoginData'),
                      (password = '')
                  "
                />
                <transition name="fade">
                  <div
                    id="login-error"
                    class="invalid-feedback fs-12 pl-2"
                    v-if="state.notifications.error.type == 'authmobile'"
                    v-text="state.notifications.error.msg"
                  ></div>
                  <div class="invalid-feedback" v-if="showInternalError">
                    <span>Something Went wrong</span>
                  </div>
                </transition>
              </div>
              <transition name="fade">
                <div
                  class="input-box mt-3 mb-2"
                  :class="loginPassClass"
                  v-if="state.sessions.user_id != 0 && mobile != ''"
                  @keyup="$store.commit('notifications/clearErrMessage')"
                >
                  <ZWInput
                    labelText="Enter Password"
                    v-model="password"
                    :type="passwordType"
                    :inputlength="4"
                    :id="'login-password'"
                    :error="loginPassClass"
                    @clearError="$store.commit('notifications/clearErrMessage')"
                  >
                    <template slot="icon">
                      <font-awesome-icon
                        :icon="passwordType == 'password' ? 'eye-slash' : 'eye'"
                        @click="
                          passwordType =
                            passwordType == 'password' ? 'text' : 'password'
                        "
                        class="icon mr-3"
                      />
                    </template>
                  </ZWInput>
                  <transition name="fade">
                    <div
                      class="invalid-feedback pl-3"
                      v-if="state.notifications.error.type == 'login'"
                      v-text="state.notifications.error.msg"
                    />
                  </transition>
                </div>
              </transition>
              <!--//Old input code-->
              <!--<div
              class="input-box mt-40"
              :class="loginMobClass"
              @keyup="clearErrorVuid"
            >
              <label id="label-phone">Phone Number</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <select class="form-control">
                    <option>
                      {{ state.system.country_details.dial_code }}
                    </option>
                  </select>
                </span>
                <input
                  id="input-phone"
                  type="number"
                  class="form-control"
                  placeholder="00000 00000"
                  v-allow.phone.number
                  v-model="mobile"
                  maxlength="10"
                  autocomplete="off"
                  :disabled="$loading"
                  v-shortkey.focus="['ctrl', 'f']"
                />
                <span class="pr-4" v-if="mobile != ''">
                  <font-awesome-icon
                    @click="clear()"
                    :icon="['fas', 'times']"
                    class="f-awesome"
                  />
                </span>
                <div
                  id="login-error"
                  class="invalid-feedback"
                  v-if="state.notifications.error.type == 'authmobile'"
                  v-text="state.notifications.error.msg"
                ></div>
                <div class="invalid-feedback" v-if="showInternalError">
                  <span>Something Went wrong</span>
                </div>
              </div>
            </div>

            <div
              class="input-box mt-20"
              v-if="state.sessions.user_id != 0 && mobile != ''"
              :class="loginPassClass"
              @keyup="$store.commit('notifications/clearErrMessage')"
              v-cloak
            >
              <label id="label-pin">Enter PIN</label>
              <div class="input-group">
                <input
                  id="input-pin"
                  type="password"
                  ref="password"
                  class="form-control"
                  placeholder="* * * *"
                  maxlength="4"
                  autocomplete="off"
                  v-model="password"
                  autofocus
                  :disabled="$loading"
                  v-shortkey.focus="['ctrl', 'f']"
                />
                <div
                  class="invalid-feedback"
                  v-if="state.notifications.error.type == 'login'"
                  v-text="state.notifications.error.msg"
                ></div>
              </div>
            </div>-->

              <div class="bottom mt-3">
                <b-button
                  type="submit"
                  size="lg"
                  block
                  variant="primary"
                  class="submit-btn"
                  :disabled="btnDisabled || loading"
                  id="login-button"
                >
                  <span>Continue</span>
                </b-button>
              </div>
            </form>
          </b-col>
          <alert-popup
            message="Opps..Something went wrong."
            type="danger"
            :show="showAlert"
          />
          <update-app-alert />
        </b-row>
      </b-container>
    </div>
    <div v-shortkey="['ctrl', 'alt', 'shift', '~']" @shortkey="alertUdid" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AlertPopup from "../components/AlertPopup";
import * as msg from "../message";
import { reject } from "q";
import UpdateAppAlert from "../components/UpdateAppAlert";
import ZWInput from "../components/ZWInput.vue";
import * as helper from "../helper";
require("clientjs");

export default {
  name: "login",
  data() {
    return {
      mobile: "",
      // mobile: '',
      isShowPassCode: false,
      btnDisabled: true,
      password: "",
      showAlert: false,
      nameState: "",
      showInternalError: false,
      passwordType: "password",
      // showModal: false
      // changeData: customData
    };
  },
  components: { AlertPopup, UpdateAppAlert, ZWInput },
  /*  created() {
        if(this.isLoggedIn) {
            this.$router.push('/billing');
        // }
    },*/
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    ...mapGetters({
      checkLicence: "system/checkLicence",
      checkOrgData: "sessions/checkOrgData",
    }),
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    forceLogin() {
      return this.state.sessions.forceLogin;
    },
    loginMobClass() {
      let check = false;
      if (this.mobile != "") {
        if (this.state.sessions.user_id != 0) {
          check = false;
        } else if (
          this.state.notifications.error.type == "authmobile" &&
          this.state.sessions.user_id == 0
        ) {
          check = true;
        }
      }
      return check;
    },
    loginPassClass() {
      let checkPass = false;
      if (this.state.notifications.error != "") {
        checkPass = true;
      } else if (
        this.state.notifications.error == "" &&
        Object.keys(this.state.sessions.user).length != 0
      ) {
        if (this.state.sessions.user.id != 0) {
          checkPass = false;
        }
      }
      return checkPass;
    },
    isLoading() {
      let check = "";
      if (this.state.sessions.loading) check = "is-disabled";

      return check;
    },
    loading() {
      return this.state.sessions.loading;
    },
    greetMessage() {
      let myDate = new Date();
      let hrs = myDate.getHours();
      let greet;
      if (hrs < 12) greet = "Good Morning";
      else if (hrs >= 12 && hrs <= 17) greet = "Good Afternoon";
      else if (hrs >= 17 && hrs <= 24) greet = "Good Evening";
      return greet;
    },
  },
  mounted() {
    if (
      !this.isOffline &&
      !this.state.system.settings.hasOwnProperty("vendor_app_menu")
    )
      this.$store.commit("system/setConnected", false);
    window.addEventListener("offline", async () => {
      if (
        !this.state.system.settings.hasOwnProperty("vendor_app_menu") &&
        (await helper.checkOfflineData())
      ) {
        console.log("login: offline");
        this.$store.commit("system/forceOfflineStatus", false);
        this.$store.commit("system/setConnected", true);
        this.$store.dispatch("system/log", {
          type: "state_change_offline_login",
          log: {},
          status: "success",
          response: "",
        });
      }
    });

    window.addEventListener("online", () => {
      if (!this.state.system.settings.hasOwnProperty("vendor_app_menu")) {
        console.log("login: online");
        this.$store.commit("system/setConnected", false);
        this.$store.dispatch("system/log", {
          type: "state_change_online_login",
          log: {},
          status: "success",
          response: "",
        });
      }
    });
    // this.showModal = true;
    if (!this.isLoggedIn) {
      this.$store.commit("clearState");
    } else {
      this.$router.push("/billing");
    }

    if (!this.checkLicence) {
      this.$router.push("/register");
    }

    // console.log(this.$parent);
    // const users = this.$data.db.user.where('mobile').equals(3200000001).first().then((item) => {
    //     console.log(item);
    // });

    // console.log(this.$store);
    // this.login();
    // var bcrypt = require('bcryptjs');
    // let hash1="$2y$10$0.5b28s2Dskj9BNgXiwiCONuih8nBZp6twBNjlplThEyZMleZZ8ri";
    // console.log(bcrypt.compareSync("1234", hash1));
  },
  watch: {
    mobile() {
      if (this.mobile.length == this.state.system.country_details.phone_digit) {
        this.btnDisabled = false;
      } else {
        this.btnDisabled = true;
      }
    },
    password() {
      if (this.password.length > 0) {
        this.btnDisabled = false;
      } else {
        this.btnDisabled = true;
      }
    },
    forceLogin(value) {
      if (value) {
        this.forceLoginBox();
      }
    },

    // changeData: {
    //   handler(val) {
    //     console.log(val);
    //   },
    //   deep: true
    // }
  },
  methods: {
    alertUdid() {
      let client = new ClientJS();
      let ua = client.getBrowserData().ua;
      let canvasPrint = client.getCanvasPrint();

      var data =
        client.getFingerprint() +
        client.getCustomFingerprint(ua, canvasPrint).toString() +
        "#" +
        client.getOSVersion();
      alert(data);
    },
    login() {
      let loginData = {};
      if (this.checkOrgData) {
        loginData = {
          trans_from: this.state.system.trans_from,
          mobile: this.mobile,
          pin: this.password,
          latitude: "",
          longitude: "",
          forcelogin: this.state.sessions.forceLogin,
          url: "/vendor/login",
        };
        this.$store
          .dispatch("sessions/login", loginData)
          .then(() => {
            this.$router.push("/billing");
            this.state.sessions.loading = false;
          })
          .catch((err) => {
            // console.log(err);
            this.state.sessions.loading = false;
            // console.log(err);
            if (err.status != 200) {
              // if (err.response.status == 500) {
              //   this.showAlert = true;
              // }
              let alertData = {
                message: msg.INTERNAL_SERVER_ERROR,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
            }
            reject(err);
          });
      } else {
        loginData = {
          trans_from: this.state.system.trans_from,
          mobile: this.mobile,
          udid: "123",
          url: "/vendor/register-mobile",
        };
        this.$store
          .dispatch("sessions/authMobile", loginData)
          .then(() => {
            this.$refs["password"].focus();
          })
          .catch((err) => {
            reject(err);
            this.state.sessions.loading = false;
          });
      }
    },
    clear() {
      // this.state.sessions.user.vu_id = "";
      this.$store.commit("sessions/clearLoginData");
      this.$store.commit("notifications/clearErrMessage");
      // this.state.sessions.user_id = 0;
      this.mobile = "";
      this.password = "";
      this.state.notifications.error = "";
    },
    forceLoginBox() {
      var self = this;
      this.$bvModal
        .msgBoxConfirm(this.state.notifications.error.msg, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Continue",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((res) => {
          if (res == null || res == false) {
            this.state.sessions.forceLogin = 0;
          } else if (res) {
            self.login();
          }
        })
        .catch(() => {});
    },
    // postData() {
    //   let cool = {
    //     trans_from: "COOL",
    //   };
    //   returnValue(cool);
    // },
    coolSu() {
      alert("Cool");
    },
    clearErrorVuid() {
      if (
        this.state.sessions.user_id != 0 ||
        this.state.notifications.error != ""
      ) {
        this.state.notifications.error = "";
        this.password = "";
        // this.mobile = "";
        this.$store.commit("sessions/clearLoginData");
        this.$store.commit("notifications/clearErrMessage");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes hide {
  0% {
    display: none;
    opacity: 0;
  }
  100% {
    display: block;
    opacity: 1;
  }
}
.login-container {
  background: $white-color;
}
.login-wrapper {
  animation: hide 0.5s linear;
  animation-fill-mode: forwards;
}
.modal-dialog .modal-body .content {
  height: 400px;
  overflow: auto;
  @include custom-scrollbar();
}
.login {
  height: calc(100vh - 73px);
  display: flex;
  // padding: 50px 0;
  align-items: center;
  overflow: auto;
  p {
    color: $grey-color;
    font-size: 1rem;
  }

  .is-error {
    border-color: $danger-dark;
  }
  .is-success {
    border-color: $green-color;
  }
  .invalid-feedback {
    color: $danger-dark;
    display: block;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.submit-btn {
  font-size: calc(0.75em + 1vmin);
}
</style>
